import { put } from "../../util/api";

export const updateFavoriteList = body => put('/api/user/favorites-list', body);
